import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.js'
import Background from './components/background/Background.jsx'
import { AuthProvider } from "./lib/AuthContext";
import './index.css'
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-H15PZJF0NS";

ReactGA.initialize(GA_MEASUREMENT_ID);
ReactGA.send({ hitType: "pageview", page: window.location.pathname });

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Background />
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
)
